"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Popover: function() {
        return _index.Popover;
    },
    renderPopover_unstable: function() {
        return _index.renderPopover_unstable;
    },
    usePopoverBase_unstable: function() {
        return _index.usePopoverBase_unstable;
    },
    usePopover_unstable: function() {
        return _index.usePopover_unstable;
    }
});
const _index = require("./components/Popover/index");
